import { Logger } from '@saviynt/common';

export const hideHostAppElements = () => {
  Logger.info('Setting classes to hide elements from host app.');
  document.getElementById('root')?.classList.add('hideHostMessages');
  document.getElementById('root')?.classList.add('hideHostLoader');
};

/**
 * Cleanup function for hideElementsFromHostApp function above
 */
export const hideHostAppElementsCleanup = () => {
  document.getElementById('root')?.classList.remove('hideHostMessages');
  document.getElementById('root')?.classList.remove('hideHostLoader');
};

/**
 * Function to remove dynamic body classes from the document.
 * It removes the 'd-block' class from the first element with
 * the class 'dynamicModules'.
 *
 * @function removeDynamicBodyClasses
 * @returns {void}
 */
export const removeDynamicBodyClasses = () => {
  const dynamicBodyEle = document.getElementsByClassName(
    'dynamicModules'
  )[0] as HTMLElement | null;

  if (dynamicBodyEle) {
    dynamicBodyEle.classList.remove('d-block');
  }
};
